(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.VejiCartOffer = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var LEGACY_TWO_MONTH_PLAN_IDS = {
    57085461758327: 718432633207,
    56473251447159: 718267646327
  };
  var SUBSCRIPTION_VARIANTS = { 57085461758327: true, 56473251447159: true };
  var CANONICAL_SEAL_PLANS = { 2: 719008039287, 3: 719007940983, 4: 719008072055, 5: 719030518135, 6: 719030550903 };
  var KNOWN_SEAL_PLANS = {
    719008039287: { cadence: 2, firstRate: 15 }, 719007940983: { cadence: 3, firstRate: 15 }, 719008072055: { cadence: 4, firstRate: 15 },
    719030518135: { cadence: 5, firstRate: 15 }, 719030550903: { cadence: 6, firstRate: 15 },
    719008104823: { cadence: 2, firstRate: 19 }, 719007973751: { cadence: 3, firstRate: 19 }, 719008137591: { cadence: 4, firstRate: 19 },
    719008170359: { cadence: 2, firstRate: 21 }, 719008203127: { cadence: 3, firstRate: 21 }, 719008006519: { cadence: 4, firstRate: 21 }
  };
  var CROSS_SELL_PRODUCTS = {
    15477127414135: { id: 15477127414135, handle: 'essentiel-vegetal' },
    15300505895287: { id: 15300505895287, handle: 'omega-3-vegetal' }
  };

  function OfferError(message) { this.name = 'OfferError'; this.message = message; }
  OfferError.prototype = Object.create(Error.prototype);
  OfferError.prototype.constructor = OfferError;
  function fail(message) { throw new OfferError(message); }
  function positiveInteger(value) { return Number.isSafeInteger(Number(value)) && Number(value) > 0; }
  function quantity(value) { return Number.isSafeInteger(value) && value >= 0; }
  function route(base, path) { return base.replace(/\/$/, '') + '/' + path; }
  function planId(item) {
    var allocation = item && item.selling_plan_allocation;
    return allocation && (allocation.selling_plan_id || allocation.selling_plan && allocation.selling_plan.id);
  }
  function isSubscription(item) { return positiveInteger(planId(item)); }
  function hasSellingPlanAllocation(item) { return !!item && Object.prototype.hasOwnProperty.call(item, 'selling_plan_allocation') && item.selling_plan_allocation !== null; }
  function handleOf(item) {
    var direct = item && (item.handle || item.product_handle);
    if (typeof direct === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(direct)) return direct;
    var match = item && typeof item.url === 'string' && item.url.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }
  function propertiesKey(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var sorted = {};
    Object.keys(source).sort().forEach(function (key) { sorted[key] = source[key]; });
    return JSON.stringify(sorted);
  }
  function lineGroup(item) {
    if (!positiveInteger(item && item.variant_id) || !quantity(item.quantity)) fail('Ligne panier invalide.');
    if (hasSellingPlanAllocation(item) && !isSubscription(item)) fail('Plan abonnement inconnu.');
    var mode = 'one-time';
    if (isSubscription(item)) {
      var id = Number(planId(item)), cadence = null;
      if (KNOWN_SEAL_PLANS[id]) cadence = KNOWN_SEAL_PLANS[id].cadence;
      mode = cadence ? 'seal|' + cadence : 'legacy|' + id;
    }
    return String(item.variant_id) + '|' + propertiesKey(item.properties) + '|' + mode;
  }
  function quantities(cart) {
    if (!cart || !Array.isArray(cart.items) || typeof cart.currency !== 'string' || !cart.currency) fail('Panier invalide.');
    return cart.items.reduce(function (result, item) {
      var key = lineGroup(item);
      result[key] = (result[key] || 0) + item.quantity;
      return result;
    }, { currency: cart.currency });
  }
  function sameQuantities(actual, expected) {
    var keys = Object.keys(actual).concat(Object.keys(expected)).filter(function (value, index, all) { return all.indexOf(value) === index; });
    if (keys.some(function (key) { return (actual[key] || 0) !== (expected[key] || 0); })) fail('Quantité panier non confirmée.');
  }
  function twoMonths(plan) {
    var options = plan && plan.options;
    return Array.isArray(options) && options.some(function (option) {
      var value = option && (option.value || Array.isArray(option.values) && option.values.join(' '));
      return typeof value === 'string' && (/2MONTH/i.test(value) || /tous les 2\s*mois/i.test(value));
    });
  }
  function adjustment(adjustments, index, orderCount, rate) {
    var item = adjustments && adjustments[index];
    return item && item.position === index + 1 && item.order_count === orderCount && item.value_type === 'percentage' && item.value === rate;
  }

  function planCadence(plan) {
    var name = plan && typeof plan.name === 'string' && plan.name.match(/^Tous les ([234]) mois$/);
    if (!name || !Array.isArray(plan.options)) return null;
    var values = [];
    plan.options.forEach(function (option) {
      var value = option && (option.value || Array.isArray(option.values) && option.values.join(' '));
      if (typeof value !== 'string') return;
      var months = value.match(/([234])MONTH/ig) || value.match(/tous les ([234])\s*mois/ig) || [];
      months.forEach(function (month) {
        var found = month.match(/[234]/);
        if (found) values.push(Number(found[0]));
      });
    });
    return values.length && values.every(function (value) { return value === Number(name[1]); }) ? Number(name[1]) : null;
  }
  function sealCadence(plan) {
    if (!plan || !Array.isArray(plan.options) || plan.options.length !== 1) return null;
    var value = plan.options[0].value;
    var match = typeof value === 'string' && value.trim().match(/^([23456])\s+(?:mois|months)$/i);
    return match ? Number(match[1]) : null;
  }
  function flat15(adjustments) {
    return Array.isArray(adjustments) && adjustments.length === 1 && adjustment(adjustments, 0, null, 15);
  }
  function sourceSealPlan(entry) {
    var id = Number(entry && entry.plan && entry.plan.id), known = KNOWN_SEAL_PLANS[id], plan = entry && entry.plan;
    if (!known || !entry || entry.group.app_id !== 'Seal Subscriptions' || !plan || plan.recurring_deliveries !== true || sealCadence(plan) !== known.cadence) fail('Plan abonnement inconnu.');
    var adjustments = plan.price_adjustments;
    var normalized = flat15(adjustments);
    var observed = !normalized && ((known.firstRate === 15 && flat15(adjustments)) ||
      (known.firstRate !== 15 && Array.isArray(adjustments) && adjustments.length === 2 && adjustment(adjustments, 0, 1, known.firstRate) && adjustment(adjustments, 1, null, 15)));
    if (!normalized && !observed) fail('Plan abonnement invalide.');
    return known;
  }
  function targetPlan(product, total, cadence) {
    if (!quantity(total) || total < 1 || [2, 3, 4, 5, 6].indexOf(cadence) === -1) fail('Quantité ou fréquence abonnement invalide.');
    var matches = allPlans(product).filter(function (entry) { return Number(entry.plan.id) === CANONICAL_SEAL_PLANS[cadence]; });
    if (matches.length !== 1) fail('Plan abonnement introuvable.');
    var entry = matches[0], plan = entry.plan;
    if (entry.group.app_id !== 'Seal Subscriptions' || plan.recurring_deliveries !== true || sealCadence(plan) !== cadence || !flat15(plan.price_adjustments)) fail('Plan abonnement invalide.');
    return plan;
  }
  function qualify(product, variantId, total, cadence, currency) {
    var spec = CROSS_SELL_PRODUCTS[Number(product && product.id)];
    if (!spec || product.handle !== spec.handle || product.available === false || !Array.isArray(product.variants) || product.variants.length !== 1 ||
      Number(product.variants[0].id) !== Number(variantId) || !SUBSCRIPTION_VARIANTS[Number(variantId)] || product.variants[0].available !== true) fail('Produit abonnement indisponible.');
    var plan = targetPlan(product, total, cadence);
    var entry = allPlans(product).filter(function (entry) { return Number(entry.plan.id) === Number(plan.id); })[0];
    var allocation = quote(product, variantId, plan, currency, product.currency);
    if (allocation.selling_plan_group_id !== entry.group.id) fail('Allocation abonnement invalide.');
    return { planId: Number(plan.id), cadence: cadence, firstRate: 15, renewalRate: 15,
      first: allocation.price, renewal: allocation.price_adjustments[allocation.price_adjustments.length - 1].price };
  }
  function allPlans(product) {
    return (product.selling_plan_groups || []).reduce(function (all, group) {
      return all.concat((group.selling_plans || []).map(function (plan) { return { group: group, plan: plan }; }));
    }, []);
  }
  function validateKnownRemovedSeal(product, variantId, currentId, allocation) {
    var known = KNOWN_SEAL_PLANS[Number(currentId)], variant = (product.variants || []).filter(function (value) { return Number(value.id) === Number(variantId); })[0];
    var plan = allocation && allocation.selling_plan;
    if (!known) fail('Plan abonnement inconnu.');
    if (!variant || !allocation || Number(allocation.selling_plan_id || plan && plan.id) !== Number(currentId) || !plan ||
      plan.recurring_deliveries !== true || sealCadence(plan) !== known.cadence) fail('Plan abonnement retiré : retirez la ligne puis choisissez une nouvelle offre.');
    var adjustments = plan.price_adjustments;
    var validPlan = flat15(adjustments) ||
      (known.firstRate !== 15 && Array.isArray(adjustments) && adjustments.length === 2 && adjustment(adjustments, 0, 1, known.firstRate) && adjustment(adjustments, 1, null, 15));
    var prices = allocation.price_adjustments;
    var expected = (adjustments || []).map(function (phase) { return Math.round(variant.price * (100 - phase.value) / 100); });
    if (!validPlan || !positiveInteger(allocation.price) || allocation.price !== expected[0] || allocation.per_delivery_price !== expected[0] ||
      !Array.isArray(prices) || prices.length !== expected.length || prices.some(function (phase, index) { return phase.position !== index + 1 || phase.price !== expected[index]; })) {
      fail('Plan abonnement retiré : retirez la ligne puis choisissez une nouvelle offre.');
    }
    return { cadence: known.cadence, legacy: true };
  }
  function sourcePlanIsAllowed(product, variantId, currentId, allocation) {
    var match = allPlans(product).filter(function (entry) { return Number(entry.plan.id) === Number(currentId); });
    if (!match.length) return validateKnownRemovedSeal(product, variantId, currentId, allocation);
    if (match.length !== 1) fail('Plan abonnement inconnu.');
    var entry = match[0];
    if (entry.group.app_id === 'Seal Subscriptions') {
      var source = sourceSealPlan(entry);
      quote(product, variantId, entry.plan, 'EUR');
      return { cadence: source.cadence, legacy: false };
    }
    var cadence = planCadence(entry.plan);
    var oldTier = ['1 personne', '2 personnes', '3 personnes'].indexOf(entry.group.name);
    var oldAdjustments = entry.plan.price_adjustments;
    var oldRates = [15, 20, 22];
    var current = entry.group.app_id === 'appstle' && cadence && oldTier >= 0 && entry.plan.recurring_deliveries === true &&
      Array.isArray(oldAdjustments) && oldAdjustments.length === (oldTier === 0 ? 1 : 2) &&
      adjustment(oldAdjustments, 0, oldTier === 0 ? null : 1, oldRates[oldTier]) && (oldTier === 0 || adjustment(oldAdjustments, 1, null, 15));
    if (current) { quote(product, variantId, entry.plan, 'EUR'); return { cadence: cadence, legacy: true }; }
    var legacyId = LEGACY_TWO_MONTH_PLAN_IDS[variantId];
    var adjustments = entry.plan.price_adjustments;
    var legacy = Number(legacyId) === Number(currentId) && entry.group.app_id !== 'appstle' && entry.plan.recurring_deliveries === true && twoMonths(entry.plan) &&
      Array.isArray(adjustments) && adjustments.length === 1 && adjustment(adjustments, 0, null, 10);
    if (!legacy) fail('Plan abonnement inconnu.');
    return { cadence: 2, legacy: true };
  }
  function quote(product, variantId, target, cartCurrency, quoteCurrency) {
    if (!cartCurrency || typeof cartCurrency !== 'string') fail('Devise panier invalide.');
    if (quoteCurrency && quoteCurrency !== cartCurrency) fail('Devise produit incompatible.');
    var variants = Array.isArray(product.variants) ? product.variants.filter(function (variant) { return Number(variant.id) === Number(variantId); }) : [];
    if (variants.length !== 1 || !positiveInteger(variants[0].price)) fail('Référence produit invalide.');
    var expectedPrices = target.price_adjustments.map(function (adjustment) { return Math.round(variants[0].price * (100 - adjustment.value) / 100); });
    var matches = Array.isArray(variants[0].selling_plan_allocations) ? variants[0].selling_plan_allocations.filter(function (allocation) {
      return allocation && Number(allocation.selling_plan_id) === Number(target.id);
    }) : [];
    if (matches.length !== 1) fail('Allocation abonnement introuvable.');
    var allocation = matches[0];
    var adjustments = allocation.price_adjustments;
    if (!positiveInteger(allocation.price) || !positiveInteger(allocation.per_delivery_price) || allocation.price !== expectedPrices[0] || allocation.per_delivery_price !== expectedPrices[0] ||
      !Array.isArray(adjustments) || adjustments.length !== expectedPrices.length || adjustments.some(function (adjustment, index) { return adjustment.position !== index + 1 || adjustment.price !== expectedPrices[index]; })) {
      fail('Allocation abonnement invalide.');
    }
    return allocation;
  }
  function createClient(options) {
    if (!options || typeof options.fetch !== 'function' || typeof options.root !== 'string' || !/^\/(?!\/)/.test(options.root)) fail('Configuration panier invalide.');
    var locked = false;
    var complementUnsafe = false;
    var products = {};
    var recoveryError = null;
    var pendingIntent = null;
    var operationWrote = false;
    var operationAdded = false;
    var readSerial = 0;
    function armIntent(before, after) {
      if (!pendingIntent) pendingIntent = [quantities(before), after];
    }
    function validateIntent(current) {
      var actual = quantities(current);
      if (pendingIntent && !pendingIntent.some(function (expected) {
        try { sameQuantities(actual, expected); return true; } catch (error) { return false; }
      })) fail('Panier modifié hors de l’intention confirmée. Vérifiez les lignes avant de poursuivre.');
      return actual;
    }
    function freshPath(path) { return path + '?_veji=' + Date.now() + '-' + (++readSerial); }
    function request(path, init, message) {
      return Promise.resolve().then(function () { return options.fetch(route(options.root, path), init); }).then(function (response) {
        if (!response || !response.ok || typeof response.json !== 'function') fail(message);
        return Promise.resolve(response.json()).catch(function () { fail(message); });
      }).catch(function (error) {
        if (error instanceof OfferError) throw error;
        fail(message);
      });
    }
    function postCart(path, payload, message) {
      var priorWrite = operationWrote;
      return Promise.resolve().then(function () {
        operationWrote = true;
        return options.fetch(route(options.root, path), {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
      }).then(function (response) {
        if (response && [400, 404, 422].indexOf(response.status) !== -1) {
          operationWrote = priorWrite;
          fail(message);
        }
        if (!response || response.ok !== true || typeof response.json !== 'function') fail('Résultat panier non confirmé.');
        if (path === 'cart/add.js') operationAdded = true;
        return response.json();
      });
    }
    function ambiguousAdd(error, added) {
      var result = error instanceof OfferError ? error : new OfferError('Ajout panier ambigu.');
      result.vejiCartAmbiguous = true;
      if (added) result.vejiCartAdded = true;
      return result;
    }
    function addRequest(items) {
      return postCart('cart/add.js', { items: items }, 'Ajout panier refusé.');
    }
    function cart() { return request(freshPath('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }, 'Panier indisponible.'); }
    function product(handle) {
      if (products[handle]) return Promise.resolve(products[handle]);
      return request(freshPath('products/' + encodeURIComponent(handle) + '.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }, 'Produit indisponible.').then(function (loaded) {
        var item = loaded && (loaded.product || loaded);
        if (!item || !Array.isArray(item.variants)) fail('Produit indisponible.');
        products[handle] = { product: item, currency: loaded.currency || item.currency || null };
        return products[handle];
      });
    }
    function freshProduct(handle) {
      return request(freshPath('products/' + encodeURIComponent(handle) + '.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }, 'Produit indisponible.').then(function (loaded) {
        var item = loaded && (loaded.product || loaded);
        if (!item || !Array.isArray(item.variants)) fail('Produit indisponible.');
        return { product: item, currency: loaded.currency || item.currency || null };
      });
    }
    function complementSpec(offer) {
      if (!offer || !positiveInteger(offer.productId) || !positiveInteger(offer.variantId) || !positiveInteger(offer.price) || !positiveInteger(offer.referencePrice) || typeof offer.currency !== 'string' || !offer.currency) fail('Offre complémentaire invalide.');
      var product = CROSS_SELL_PRODUCTS[Number(offer.productId)];
      if (!product) fail('Offre complémentaire invalide.');
      var sellingPlan = offer.sellingPlan === null || offer.sellingPlan === undefined || offer.sellingPlan === '' ? null : offer.sellingPlan;
      if (sellingPlan !== null && !positiveInteger(sellingPlan)) fail('Offre complémentaire invalide.');
      return { product: product, variantId: Number(offer.variantId), price: Number(offer.price), referencePrice: Number(offer.referencePrice), sellingPlan: sellingPlan === null ? null : Number(sellingPlan), currency: offer.currency };
    }
    function complementSource(current) {
      if (!current || !Array.isArray(current.items) || typeof current.currency !== 'string' || !current.currency) fail('Panier invalide.');
      var present = {};
      current.items.forEach(function (item) {
        var id = Number(item && item.product_id);
        if (!CROSS_SELL_PRODUCTS[id]) return;
        if (!positiveInteger(item.quantity)) fail('Quantité panier invalide.');
        if (!present[id]) present[id] = [];
        present[id].push(item);
      });
      var ids = Object.keys(present);
      if (ids.length !== 1) return null;
      var source = CROSS_SELL_PRODUCTS[Number(ids[0])];
      var modes = present[ids[0]].map(function (item) {
        if (hasSellingPlanAllocation(item) && !isSubscription(item)) fail('Plan abonnement inconnu.');
        return isSubscription(item) ? 'subscription' : 'one-time';
      }).filter(function (mode, index, all) { return all.indexOf(mode) === index; });
      return { product: source, lines: present[ids[0]], mode: modes.length === 1 ? modes[0] : 'one-time' };
    }
    function complementSnapshot(current) {
      return current.items.map(function (item) {
        if (!item || typeof item.key !== 'string' || !item.key) fail('Ligne panier invalide.');
        lineGroup(item);
        return { key: item.key, productId: item.product_id, variantId: item.variant_id, quantity: item.quantity, properties: propertiesKey(item.properties), hasPlan: hasSellingPlanAllocation(item), planId: planId(item) || null };
      });
    }
    function sameOriginals(current, originals) {
      function totals(lines) {
        return lines.reduce(function (result, item) {
          var key = item.productId + '|' + item.variantId + '|' + item.properties + '|' + item.hasPlan + '|' + (item.planId || 'once');
          result[key] = (result[key] || 0) + item.quantity;
          return result;
        }, {});
      }
      sameQuantities(totals(complementSnapshot(current)), totals(originals));
    }
    function checkComplementFinal(current, action) {
      if (current.currency !== action.currency) fail('Devise panier modifiée.');
      if (current.items.filter(function (item) { return Number(item.product_id) === action.target.id; }).length !== 1) fail('Panier complémentaire non confirmé.');
      sameOriginals({ items: current.items.filter(function (item) { return Number(item.product_id) !== action.target.id; }) }, action.originals);
      var matches = current.items.filter(function (item) {
        return Number(item && item.product_id) === action.target.id && Number(item.variant_id) === action.variantId && item.quantity === 1 &&
          propertiesKey(item.properties) === '{}' &&
          (action.sellingPlan ? Number(planId(item)) === action.sellingPlan : !hasSellingPlanAllocation(item));
      });
      if (matches.length !== 1) fail('Panier complémentaire non confirmé.');
      return checkFinal(current, validateIntent(current));
    }
    function complementaryQuote(current, targetId, loadProduct) {
      var source = complementSource(current);
      if (!source) return Promise.resolve(null);
      var target = source.product.id === CROSS_SELL_PRODUCTS[15477127414135].id ? CROSS_SELL_PRODUCTS[15300505895287] : CROSS_SELL_PRODUCTS[15477127414135];
      if (Number(targetId) !== target.id) return Promise.resolve(null);
      loadProduct = loadProduct || freshProduct;
      return Promise.all([loadProduct(source.product.handle), loadProduct(target.handle)]).then(function (loaded) {
        var sourceLoaded = loaded[0];
        var targetLoaded = loaded[1];
        if (!sourceLoaded.product || Number(sourceLoaded.product.id) !== source.product.id || !targetLoaded.product || Number(targetLoaded.product.id) !== target.id || targetLoaded.product.available === false) fail('Produit indisponible.');
        // Validate every subscription before applying the business ambiguity fallback.
        var cadences = source.lines.filter(isSubscription).map(function (line) {
          return sourcePlanIsAllowed(sourceLoaded.product, line.variant_id, planId(line), line.selling_plan_allocation).cadence;
        }).filter(function (value, index, all) { return all.indexOf(value) === index; });
        var cadence = source.mode === 'subscription' && cadences.length === 1 ? cadences[0] : null;
        var variants = targetLoaded.product.variants;
        if (variants.length !== 1 || variants[0].available !== true || !positiveInteger(variants[0].price)) fail('Produit indisponible.');
        if (targetLoaded.currency && targetLoaded.currency !== current.currency) fail('Offre complémentaire expirée.');
        var qualified = cadence ? qualify(targetLoaded.product, variants[0].id, 1, cadence, current.currency) : null;
        var offer = { productId: target.id, variantId: Number(variants[0].id), price: qualified ? qualified.first : variants[0].price,
          referencePrice: variants[0].price, sellingPlan: qualified ? qualified.planId : null, cadence: cadence, currency: current.currency };
        offer.signature = JSON.stringify(offer);
        return offer;
      });
    }
    function complementAction(current, offer) {
      var spec = complementSpec(offer);
      return complementaryQuote(current, spec.product.id).then(function (fresh) {
        if (!fresh || typeof offer.signature !== 'string' || offer.signature !== fresh.signature || spec.variantId !== fresh.variantId ||
          spec.price !== fresh.price || spec.referencePrice !== fresh.referencePrice || spec.sellingPlan !== fresh.sellingPlan || spec.currency !== fresh.currency || offer.cadence !== fresh.cadence) fail('Offre complémentaire actualisée. Vérifiez-la puis cliquez à nouveau.');
        armIntent(current, addedExpected(current, [{ id: fresh.variantId, quantity: 1, selling_plan: fresh.sellingPlan }]));
        return { target: spec.product, variantId: fresh.variantId, sellingPlan: fresh.sellingPlan, currency: fresh.currency, originals: complementSnapshot(current) };
      });
    }
    function addComplementRequest(action) {
      var item = { id: action.variantId, quantity: 1 };
      if (action.sellingPlan) item.selling_plan = action.sellingPlan;
      return addRequest([item]);
    }
    function confirmComplement(action) {
      return cart().then(function (current) { return checkComplementFinal(current, action); }, function () {
        complementUnsafe = true;
        fail('Panier non confirmé.');
      });
    }
    function inspect(current) {
      if (!current || !Array.isArray(current.items) || typeof current.currency !== 'string' || !current.currency) fail('Panier invalide.');
      var groups = {};
      var chain = Promise.resolve();
      current.items.forEach(function (item, index) {
        lineGroup(item);
        if (!isSubscription(item)) return;
        chain = chain.then(function () {
          var handle = handleOf(item);
          if (!handle) fail('Référence panier introuvable.');
          return product(handle).then(function (loaded) {
            var source = sourcePlanIsAllowed(loaded.product, item.variant_id, planId(item), item.selling_plan_allocation);
            var key = String(item.variant_id) + '|' + (source.legacy ? 'legacy|' + planId(item) : source.cadence);
            if (!groups[key]) groups[key] = { variantId: item.variant_id, cadence: source.cadence, legacy: source.legacy, total: 0, lines: [], loaded: loaded };
            groups[key].total += item.quantity;
            groups[key].lines.push({ item: item, index: index, loaded: loaded });
          });
        });
      });
      return chain.then(function () {
        Object.keys(groups).forEach(function (key) {
          var group = groups[key];
          if (!group.legacy) {
            group.target = targetPlan(group.loaded.product, group.total, group.cadence);
            group.allocation = quote(group.loaded.product, group.variantId, group.target, current.currency, group.loaded.currency);
          }
        });
        return groups;
      });
    }
    function checkFinal(current, expected) {
      sameQuantities(quantities(current), expected);
      return inspect(current).then(function (groups) {
        Object.keys(groups).forEach(function (key) {
          var group = groups[key];
          if (group.legacy) return;
          group.lines.forEach(function (line) {
            if (Number(planId(line.item)) !== Number(group.target.id) || !Number.isFinite(line.item.final_line_price) || line.item.final_line_price < 0 || line.item.final_line_price > group.allocation.price * line.item.quantity) {
              fail('Panier abonnement non conforme.');
            }
          });
        });
        return current;
      });
    }
    function reconcileFrom(current, expected, remaining) {
      if (remaining < 0) fail('Réconciliation panier incomplète.');
      sameQuantities(quantities(current), expected);
      return inspect(current).then(function (groups) {
        var change;
        Object.keys(groups).some(function (key) {
          var group = groups[key];
          if (group.legacy) return false;
          return group.lines.some(function (line) {
            if (Number(planId(line.item)) !== Number(group.target.id)) { change = { line: line, plan: group.target }; return true; }
            return false;
          });
        });
        if (!change) return checkFinal(current, expected);
        return postCart('cart/change.js', { line: change.line.index + 1, quantity: change.line.item.quantity, selling_plan: change.plan.id }, 'Mise à jour du panier refusée.').then(function (updated) {
          sameQuantities(quantities(updated), expected);
          return reconcileFrom(updated, expected, remaining - 1);
        });
      });
    }
    function reconcileCurrent(current, expected) {
      if (current.items.length > 50) fail('Panier trop volumineux.');
      armIntent(current, expected);
      return reconcileFrom(current, expected, current.items.length * 2 + 4);
    }
    function changedExpected(current, item, nextQuantity) {
      var expected = quantities(current);
      var key = lineGroup(item);
      expected[key] = expected[key] - item.quantity + nextQuantity;
      if (!expected[key]) delete expected[key];
      return expected;
    }
    function addedExpected(current, items) {
      var expected = quantities(current);
      items.forEach(function (item) {
        if (!item || !positiveInteger(item.id) || !positiveInteger(item.quantity)) fail('Ajout panier invalide.');
        var fake = { variant_id: Number(item.id), quantity: item.quantity, properties: item.properties, selling_plan_allocation: item.selling_plan ? { selling_plan_id: item.selling_plan } : null };
        var key = lineGroup(fake);
        expected[key] = (expected[key] || 0) + item.quantity;
      });
      return expected;
    }
    function prepareAddition(current, items) {
      return inspect(current).then(function (groups) {
        return Promise.all(items.map(function (item) {
          var copy = { id: Number(item.id), quantity: item.quantity };
          if (item.properties) copy.properties = item.properties;
          if (!item.selling_plan) return copy;
          var known = Number(item.id) === 57085461758327 ? CROSS_SELL_PRODUCTS[15477127414135] : Number(item.id) === 56473251447159 ? CROSS_SELL_PRODUCTS[15300505895287] : null;
          if (!known) fail('Produit abonnement inconnu.');
          return product(known.handle).then(function (loaded) {
            var source = sourcePlanIsAllowed(loaded.product, item.id, item.selling_plan);
            if (source.legacy) fail('Nouveaux abonnements : plan Seal requis.');
            var total = item.quantity;
            Object.keys(groups).forEach(function (key) {
              var group = groups[key];
              if (!group.legacy && Number(group.variantId) === Number(item.id) && group.cadence === source.cadence) total += group.total;
            });
            items.forEach(function (other) {
              if (other === item || Number(other.id) !== Number(item.id) || !other.selling_plan) return;
              var otherSource = sourcePlanIsAllowed(loaded.product, other.id, other.selling_plan);
              if (!otherSource.legacy && otherSource.cadence === source.cadence) total += other.quantity;
            });
            copy.selling_plan = qualify(loaded.product, item.id, total, source.cadence, current.currency).planId;
            return copy;
          });
        }));
      });
    }
    function subscriptionExpected(current, item, cadence) {
      var expected = quantities(current);
      var source = lineGroup(item);
      var destination = String(item.variant_id) + '|' + propertiesKey(item.properties) + '|seal|' + cadence;
      expected[source] -= item.quantity;
      if (!expected[source]) delete expected[source];
      expected[destination] = (expected[destination] || 0) + item.quantity;
      return expected;
    }
    function signatureValue(value) {
      if (Array.isArray(value)) return value.map(signatureValue);
      if (value && typeof value === 'object') {
        var sorted = {};
        Object.keys(value).sort().forEach(function (key) { sorted[key] = signatureValue(value[key]); });
        return sorted;
      }
      return value;
    }
    function conversionSignature(current, item, total, target, allocation) {
      return JSON.stringify({
        cart: current.items.map(function (line) {
          return { key: line.key, variantId: line.variant_id, quantity: line.quantity, properties: signatureValue(line.properties || {}), sellingPlanAllocation: signatureValue(line.selling_plan_allocation) };
        }),
        key: item.key, currency: current.currency, groupQuantity: total, planId: target.id,
        firstLinePrice: allocation.price * item.quantity,
        renewalLinePrice: allocation.price_adjustments[allocation.price_adjustments.length - 1].price * item.quantity
      });
    }
    function conversionOffer(current, key) {
      if (!current || !Array.isArray(current.items) || typeof current.currency !== 'string' || !current.currency) fail('Panier invalide.');
      var matches = current.items.filter(function (item) { return item && item.key === key; });
      if (matches.length !== 1) fail('Ligne panier introuvable.');
      var item = matches[0];
      if (!SUBSCRIPTION_VARIANTS[item.variant_id] || !positiveInteger(item.quantity)) fail('Ligne panier non éligible.');
      if (hasSellingPlanAllocation(item)) fail('Ligne déjà abonnement.');
      var handle = handleOf(item);
      if (!handle) fail('Référence panier introuvable.');
      return freshProduct(handle).then(function (fresh) {
        var variants = fresh.product && Array.isArray(fresh.product.variants) ? fresh.product.variants.filter(function (variant) { return Number(variant.id) === Number(item.variant_id); }) : [];
        if (fresh.product.available === false || variants.length !== 1 || variants[0].available === false) fail('Produit indisponible.');
        current.items.forEach(function (line) {
          if (Number(line.variant_id) !== Number(item.variant_id)) return;
          if (!positiveInteger(line.quantity)) fail('Quantité panier invalide.');
          if (hasSellingPlanAllocation(line) && !isSubscription(line)) fail('Plan abonnement inconnu.');
        });
        var subscriptions = current.items.filter(function (line) {
          return line !== item && Number(line.variant_id) === Number(item.variant_id) && isSubscription(line);
        });
        var cadences = subscriptions.map(function (line) {
          if (!quantity(line.quantity) || line.quantity < 1) fail('Quantité panier invalide.');
          var source = sourcePlanIsAllowed(fresh.product, line.variant_id, planId(line), line.selling_plan_allocation);
          if (source.legacy) fail('Plan abonnement historique non modifiable.');
          return source.cadence;
        });
        cadences = cadences.filter(function (value, index, all) { return all.indexOf(value) === index; });
        if (cadences.length > 1) fail('Fréquence abonnement ambiguë.');
        var sourceCadence = cadences.length ? cadences[0] : 2;
        var total = item.quantity + subscriptions.reduce(function (sum, line) { return sum + line.quantity; }, 0);
        var target = targetPlan(fresh.product, total, sourceCadence);
        var allocation = quote(fresh.product, item.variant_id, target, current.currency, fresh.currency);
        return {
          key: item.key, variantId: item.variant_id, quantity: item.quantity, groupQuantity: total, currency: current.currency,
          firstLinePrice: allocation.price * item.quantity, renewalLinePrice: allocation.price_adjustments[allocation.price_adjustments.length - 1].price * item.quantity,
          firstRate: target.price_adjustments[0].value, planId: target.id,
          signature: conversionSignature(current, item, total, target, allocation), item: item, loaded: fresh, cadence: sourceCadence
        };
      });
    }
    function reconcileConvertedFrom(current, expected, variantId, loaded, cadence, remaining) {
      if (remaining < 0) fail('Réconciliation panier incomplète.');
      sameQuantities(quantities(current), expected);
      var lines = current.items.map(function (item, index) { return { item: item, index: index }; }).filter(function (line) {
        if (Number(line.item.variant_id) !== Number(variantId) || !isSubscription(line.item)) return false;
        var source = sourcePlanIsAllowed(loaded.product, line.item.variant_id, planId(line.item), line.item.selling_plan_allocation);
        return !source.legacy && source.cadence === cadence;
      });
      var total = lines.reduce(function (sum, line) { return sum + line.item.quantity; }, 0);
      if (!total) fail('Panier abonnement non conforme.');
      var target = targetPlan(loaded.product, total, cadence);
      var allocation = quote(loaded.product, variantId, target, current.currency, loaded.currency);
      var change = lines.filter(function (line) { return Number(planId(line.item)) !== Number(target.id); })[0];
      if (!change) {
        lines.forEach(function (line) {
          if (!Number.isFinite(line.item.final_line_price) || line.item.final_line_price < 0 || line.item.final_line_price > allocation.price * line.item.quantity) fail('Panier abonnement non conforme.');
        });
        return Promise.resolve(current);
      }
      return postCart('cart/change.js', { line: change.index + 1, quantity: change.item.quantity, selling_plan: target.id }, 'Mise à jour du panier refusée.').then(function (updated) {
        return reconcileConvertedFrom(updated, expected, variantId, loaded, cadence, remaining - 1);
      });
    }
    function purchaseOffer(current, key, cadence, loadProduct) {
      quantities(current);
      if (cadence !== null && [2, 3, 4, 5, 6].indexOf(cadence) === -1) fail('Fréquence abonnement invalide.');
      var matches = current.items.filter(function (item) { return item.key === key; });
      if (matches.length !== 1 || !SUBSCRIPTION_VARIANTS[matches[0].variant_id] || !positiveInteger(matches[0].quantity)) fail('Ligne panier non éligible.');
      var item = matches[0], handle = handleOf(item);
      if (!handle) fail('Référence panier introuvable.');
      return (loadProduct || freshProduct)(handle).then(function (loaded) {
        if (current.currency !== 'EUR' || (loaded.currency && loaded.currency !== current.currency)) fail('Devise produit incompatible.');
        var sourceCadence = null, totals = {};
        current.items.forEach(function (line) {
          if (Number(line.variant_id) !== Number(item.variant_id)) return;
          if (!positiveInteger(line.quantity)) fail('Quantité panier invalide.');
          if (!isSubscription(line)) return;
          var source = sourcePlanIsAllowed(loaded.product, line.variant_id, planId(line), line.selling_plan_allocation);
          if (line === item && source.legacy && cadence !== null) fail('Plan abonnement retiré : choisissez achat unique ou retirez la ligne.');
          if (source.legacy) return;
          if (line === item) sourceCadence = source.cadence;
          else totals[source.cadence] = (totals[source.cadence] || 0) + line.quantity;
        });
        // Qualify both destination and remaining source group before any write.
        var qualified = qualify(loaded.product, item.variant_id, (totals[cadence] || 0) + item.quantity, cadence || 2, current.currency);
        if (sourceCadence && sourceCadence !== cadence && totals[sourceCadence]) qualify(loaded.product, item.variant_id, totals[sourceCadence], sourceCadence, current.currency);
        var offer = {
          key: key, variantId: item.variant_id, properties: propertiesKey(item.properties), quantity: item.quantity,
          currency: current.currency, currentPlanId: planId(item) || null, currentLinePrice: item.final_line_price, currentTotal: current.total_price,
          cadence: cadence, sourceCadence: sourceCadence, planId: cadence ? qualified.planId : null,
          firstLinePrice: (cadence ? qualified.first : loaded.product.variants[0].price) * item.quantity,
          renewalLinePrice: cadence ? qualified.renewal * item.quantity : null
        };
        offer.signature = JSON.stringify({ offer: offer, cart: signatureValue(current.items.map(function (line) {
          return { key: line.key, variant: line.variant_id, quantity: line.quantity, properties: line.properties || {}, allocation: line.selling_plan_allocation || null, price: line.final_line_price };
        })) });
        return { offer: offer, current: current, item: item, loaded: loaded };
      });
    }
    function applyPurchase(fresh) {
      var offer = fresh.offer;
      var expected = changedExpected(fresh.current, fresh.item, 0);
      var destination = String(offer.variantId) + '|' + offer.properties + '|' + (offer.cadence ? 'seal|' + offer.cadence : 'one-time');
      expected[destination] = (expected[destination] || 0) + offer.quantity;
      armIntent(fresh.current, expected);
      var affected = [offer.sourceCadence, offer.cadence].filter(function (value, index, all) { return value && all.indexOf(value) === index; });
      function reconcileAffected(current) {
        sameQuantities(quantities(current), expected);
        var chain = Promise.resolve(current);
        affected.forEach(function (cadence) {
          chain = chain.then(function (cart) {
            var present = cart.items.some(function (line) { return Number(line.variant_id) === Number(offer.variantId) && isSubscription(line) && sealCadence(line.selling_plan_allocation.selling_plan) === cadence; });
            if (!present) return cart;
            return reconcileConvertedFrom(cart, expected, offer.variantId, fresh.loaded, cadence, cart.items.length * 2 + 4);
          });
        });
        return chain;
      }
      return postCart('cart/change.js', { line: fresh.current.items.indexOf(fresh.item) + 1, quantity: offer.quantity, selling_plan: offer.planId }, 'Mise à jour du panier refusée.')
        .then(reconcileAffected).then(function () { return cart(); }).then(function (confirmed) {
          sameQuantities(quantities(confirmed), expected);
          return checkFinal(confirmed, expected);
        });
    }
    function run(work, recovery) {
      if (locked) return Promise.reject(new OfferError('Une mise à jour du panier est déjà en cours.'));
      if ((recoveryError || complementUnsafe) && !recovery) return Promise.reject(recoveryError || new OfferError('Panier non confirmé.'));
      locked = true;
      products = {};
      operationWrote = false;
      operationAdded = false;
      if (!recoveryError) pendingIntent = null;
      return Promise.resolve().then(work).then(function (result) {
        if (recovery) { recoveryError = null; complementUnsafe = false; }
        pendingIntent = null;
        return result;
      }).catch(function (error) {
        if (!operationWrote) throw error;
        var guarded = ambiguousAdd(error, operationAdded);
        recoveryError = guarded;
        // Read only after an uncertain write. Requalification is an explicit recovery action.
        return cart().then(function (current) { return checkFinal(current, validateIntent(current)); }).then(function () {
          guarded.vejiCartReadbackConfirmed = true;
          throw guarded;
        }, function () { throw guarded; });
      }).finally(function () { locked = false; });
    }
    return {
      busy: function () { return locked; },
      complementSafe: function () { return !complementUnsafe && !recoveryError; },
      verify: function () { return run(function () { return cart().then(function (current) { return checkFinal(current, quantities(current)); }); }); },
      reconcile: function () { return run(function () { return cart().then(function (current) { return reconcileCurrent(current, validateIntent(current)); }); }, true); },
      previewOffers: function (purchases, complements) {
        return run(function () {
          if (!Array.isArray(purchases) || !Array.isArray(complements)) fail('Préparation panier invalide.');
          // Display-only batch: one fresh cart, shared in-flight product reads.
          // Nothing is cached across calls; mutation and checkout paths stay fresh.
          var reads = Object.create(null);
          var result = { purchases: Object.create(null), complements: Object.create(null) };
          function loadProduct(handle) {
            if (!reads[handle]) reads[handle] = freshProduct(handle);
            return reads[handle];
          }
          return cart().then(function (current) {
            var tasks = purchases.map(function (request) {
              return Promise.resolve().then(function () { return purchaseOffer(current, request.key, request.cadence, loadProduct); })
                .then(function (fresh) { result.purchases[request.key] = fresh.offer; }, function () { result.purchases[request.key] = null; });
            }).concat(complements.map(function (id) {
              return Promise.resolve().then(function () { return complementaryQuote(current, id, loadProduct); })
                .then(function (offer) { result.complements[id] = offer; }, function () { result.complements[id] = null; });
            }));
            return Promise.all(tasks).then(function () { return result; });
          });
        });
      },
      previewPurchase: function (key, cadence) {
        return run(function () { return cart().then(function (current) { return purchaseOffer(current, key, cadence); }).then(function (fresh) { return fresh.offer; }); });
      },
      changePurchase: function (key, cadence, offer) {
        return run(function () {
          if (!offer || typeof offer.signature !== 'string') fail('Offre abonnement invalide.');
          return cart().then(function (current) { return purchaseOffer(current, key, cadence); }).then(function (fresh) {
            if (fresh.offer.signature !== offer.signature) fail('Offre abonnement actualisée. Vérifiez le panier puis réessayez.');
            return applyPurchase(fresh);
          });
        });
      },
      previewSubscription: function (key) {
        return run(function () {
          if (typeof key !== 'string' || !key) fail('Modification panier invalide.');
          return cart().then(function (current) { return conversionOffer(current, key); }).then(function (offer) {
            delete offer.item;
            delete offer.loaded;
            return offer;
          });
        });
      },
      subscribe: function (key, offer) {
        return run(function () {
          if (typeof key !== 'string' || !key || !offer || typeof offer.signature !== 'string') fail('Offre abonnement invalide.');
          return cart().then(function (current) {
            return conversionOffer(current, key).then(function (fresh) { fresh.current = current; return fresh; });
          }).then(function (fresh) {
            if (fresh.signature !== offer.signature) fail('Offre abonnement expirée.');
            var expected = subscriptionExpected(fresh.current, fresh.item, fresh.cadence);
            armIntent(fresh.current, expected);
            var index = fresh.current.items.indexOf(fresh.item);
            return postCart('cart/change.js', { line: index + 1, quantity: fresh.item.quantity, selling_plan: fresh.planId }, 'Mise à jour du panier refusée.').then(function (updated) {
              return reconcileConvertedFrom(updated, expected, fresh.variantId, fresh.loaded, fresh.cadence, updated.items.length * 2 + 4);
            });
          });
        });
      },
      change: function (key, nextQuantity) {
        return run(function () {
          if (typeof key !== 'string' || !key || !quantity(nextQuantity)) fail('Modification panier invalide.');
          return cart().then(function (current) {
            var index = current.items.findIndex(function (item) { return item.key === key; });
            if (index < 0) fail('Ligne panier introuvable.');
            return inspect(current).then(function (groups) {
              var item = current.items[index];
              var payload = { line: index + 1, quantity: nextQuantity };
              if (isSubscription(item)) {
                var group = Object.keys(groups).map(function (key) { return groups[key]; }).filter(function (group) {
                  return group.lines.some(function (line) { return line.item === item; });
                })[0];
                if (group.legacy && nextQuantity > 0 && nextQuantity !== item.quantity) fail('Ancien abonnement : retirez la ligne puis choisissez une nouvelle offre.');
                payload.selling_plan = nextQuantity && !group.legacy
                  ? targetPlan(group.loaded.product, group.total - item.quantity + nextQuantity, group.cadence).id : planId(item);
              }
              var expected = changedExpected(current, item, nextQuantity);
              armIntent(current, expected);
              return postCart('cart/change.js', payload, 'Mise à jour du panier refusée.').then(function (updated) {
                sameQuantities(quantities(updated), expected);
                return reconcileCurrent(updated, expected);
              });
            });
          });
        });
      },
      previewComplement: function (productId) {
        return run(function () { return cart().then(function (current) { return complementaryQuote(current, productId); }); });
      },
      addComplement: function (offer) {
        return run(function () {
          if (complementUnsafe) fail('Panier non confirmé.');
          return cart().then(function (current) { return complementAction(current, offer); }).then(function (action) {
            return addComplementRequest(action).then(function () {
              return confirmComplement(action);
            });
          });
        });
      },
      add: function (items) {
        return run(function () {
          if (!Array.isArray(items) || !items.length) fail('Ajout panier invalide.');
          return cart().then(function (before) {
            var expected = addedExpected(before, items);
            armIntent(before, expected);
            return prepareAddition(before, items).then(addRequest).then(function () {
              return cart().then(function (updated) {
                sameQuantities(quantities(updated), expected);
                return reconcileCurrent(updated, expected);
              }).catch(function (error) {
                throw ambiguousAdd(error, true);
              });
            });
          });
        });
      }
    };
  }
  return { OfferError: OfferError, createClient: createClient, qualify: qualify };
}));
